import React, { useState, useEffect } from "react";
import { GoogleMap, LoadScript, Marker, InfoWindow } from "@react-google-maps/api";

const mapContainerStyle = {
  width: "100%",
  height: "100%",
};

const defaultCenter = {
  lat: 17.385044,
  lng: 78.486671,
};

const RehabCenterMap = ({ rehabCenters = [], center: mapCenterProp }) => {
  const [selected, setSelected] = useState(null);
  const [currentCenter, setCurrentCenter] = useState(defaultCenter);

  useEffect(() => {
    // Prioritize the specific center passed from the locator
    if (mapCenterProp) {
      setCurrentCenter(mapCenterProp);
    } 
    // If no specific center, but there are results, center on the first one
    else if (rehabCenters.length > 0 && rehabCenters[0].geometry?.location) {
      setCurrentCenter(rehabCenters[0].geometry.location);
    }
    // Otherwise, keep the last known center (or default)
  }, [rehabCenters, mapCenterProp]);

  const handleMouseOver = (rehabCenter) => {
    setSelected({
      lat: rehabCenter.geometry.location.lat,
      lng: rehabCenter.geometry.location.lng,
      name: rehabCenter.name,
      address: rehabCenter.formatted_address || rehabCenter.vicinity,
    });
  };

  return (
    <LoadScript googleMapsApiKey={process.env.REACT_APP_GOOGLE_MAPS_API_KEY}>
      <GoogleMap mapContainerStyle={mapContainerStyle} center={currentCenter} zoom={12}>
        {rehabCenters.map((rehabCenter, index) =>
          rehabCenter.geometry && rehabCenter.geometry.location ? (
            <Marker
              key={index}
              position={{
                lat: rehabCenter.geometry.location.lat,
                lng: rehabCenter.geometry.location.lng,
              }}
              onMouseOver={() => handleMouseOver(rehabCenter)}
            />
          ) : null
        )}

        {selected && (
          <InfoWindow
            position={{ lat: selected.lat, lng: selected.lng }}
            onCloseClick={() => {
              setSelected(null);
            }}
          >
            <div>
              <h2>{selected.name}</h2>
              <p>{selected.address}</p>
            </div>
          </InfoWindow>
        )}
      </GoogleMap>
    </LoadScript>
  );
};

export default RehabCenterMap;
